class SiteDrawer extends window.BAO.CustomElement() {
  CLASSES = {
    activeDrawerClass: 'drw-Drawer-active',
  }

  constructor () {
    super()

    this.drawers = window.BAO.utils.getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
    this._moved = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved && !this._moved) {
      window.setTimeout(() => {
        this._moved = true
        this.moveToElement.appendChild(this)
        this.removeAttribute('data-module-drawers-move-me')
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: window.BAO.utils.getElement(
        `[data-drawers-trigger=${this.key}]`,
      ),
      close: window.BAO.utils.getElement(
        `[data-module-drawers-close=${this.key}]`,
      ),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.CLASSES.activeDrawerClass, val)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      case 'over':
        return this.drawers.els.drawer.element
      default:
        return window.BAO.utils.getElement(
          this.getAttribute('data-module-drawers-move-me'),
        )
    }
  }
}

customElements.define('site-drawer', SiteDrawer)
